var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wh100" },
    [
      _c(
        "el-table",
        {
          staticClass: "mt30",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.rcvActRecList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "ts",
              label: "操作时间",
              align: "center",
              width: "220"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "action",
              label: "动作",
              width: "150",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "actRole",
              label: "操作人身份",
              width: "150",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "actorName",
              label: "操作人",
              width: "200",
              align: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "actDesc",
              label: "附加信息",
              "show-overflow-tooltip": "",
              align: "left"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-259844f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-259844f9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/payment/RcvActRecList.vue
// module id = 2036
// module chunks = 1